export const STORAGE_PATH = "storage/"
export const STORAGE_INTERBU_BY_CLUSTER_PATH = `${STORAGE_PATH}interbu/by-cluster/`
export const ROOT_PATH = "shared/"
export const NIL_UUID = "00000000-0000-4000-8000-000000000000"
export const BARNES_SHOP = "https://barnes.monwebtoprint.fr/login"
